export const removeAccents = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

export const capitalize = (str) => str.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase())
